import {Drawer} from 'antd';
import styled from 'styled-components';

const StyledAddVendorModal = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    button {
      margin-inline-end: 0;
      margin-inline-start: 12px;
    }
  }
  .ant-drawer-title {
    font-weight: 500;
  }
  .ant-drawer-footer {
    display: flex;
    flex-direction: row;
    justify-content: end;
    padding: 16px 24px;
    
    button {
      &:not(:last-of-type) {
        margin-right: 16px;
      }
    }
  }

  .d-none-label {
    .ant-form-item-label {
      display: none;
    }
  }
  
  .ant-divider {
    margin-bottom: 12px;
  }
  
  .ant-alert {
    align-items: baseline;
  }
`;


export {
  StyledAddVendorModal,
}
